import { render, staticRenderFns } from "./liveStreaming.vue?vue&type=template&id=71ec90e2&scoped=true"
import script from "./liveStreaming.vue?vue&type=script&lang=js"
export * from "./liveStreaming.vue?vue&type=script&lang=js"
import style0 from "./liveStreaming.vue?vue&type=style&index=0&id=71ec90e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec90e2",
  null
  
)

export default component.exports